import React, { FC } from 'react'
import Authorization from '../../../types/Authorization'
import Provider from '../../../types/Provider'
import { Col, Container, Modal, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { truncate, formatNoUTCDate } from '../../../utils/stringTools'
import { formatDate, formatPhoneNumber } from '../../../utils/dataTools'
import moment from 'moment'
import './index.css'

interface Props {
  authorization: Authorization;
  isOrganization: boolean;
  provider: Provider;
  show: boolean;
  onClose: () => void;
  onDownloadPdf: () => void;
}

const AuthorizationDetailModal: FC<Props> = (props: Props) => {
  const { authorization, isOrganization, provider, show, onClose } = props

  return (
    <Modal size="xl" show={show} onHide={onClose}>
      <Modal.Header closeButton id="authorization-detail-header">
        <div className='authorization-detail-header-txt'>
          <div style={{display:'flex'}}>
            <FontAwesomeIcon icon={['fas', 'user-circle']} size="lg" className="authorization-detail-header-icon" />
            <Modal.Title id="authorization-detail-header-title">Authorization Detail</Modal.Title>
          </div>
          {/* <span className='authorization-detail-download-btn' onClick={onDownloadPdf}>Download pdf</span> */}
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className='authorization-detail-container'>
          <Container id='downloadPdf' style={{width:'75%'}}>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Member ID
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.memberId
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Member Name
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.memberName.trim() !== ',' ? authorization.memberName : ''
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Member DOB
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.memberDob ? formatNoUTCDate(truncate(10, authorization.memberDob)) : ''
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									MCI
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.memberMci
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									SSN
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.memberSsn
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Care Manager
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.careManager
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Care Manager Phone
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.careManagerPhone ? formatPhoneNumber(authorization.careManagerPhone) : ''
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									RN
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.rn
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									RN Phone
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.rnPhone ? formatPhoneNumber(authorization.rnPhone) : ''
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Auth No
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.authorizationNumber
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Entered On Date
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    formatNoUTCDate(truncate(10,authorization.lastStatusChangeDate))
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Service Code
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.serviceCode
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Service Type
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.serviceCategory
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Procedure
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.procedureName
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Service Provider
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    isOrganization?authorization.serviceProvider:provider.provider_name
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Provider Address
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    isOrganization?authorization.providerAddress:provider.address_1+' '+provider.address_2+' '+provider.city+' '+provider.state+' '+provider.zip_code
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Provider Phone
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    formatPhoneNumber(isOrganization?authorization.providerPhone:provider.phone)
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Service Start Date
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    formatNoUTCDate(formatDate(authorization.authorizationStartDate))
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Service End Date
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    formatNoUTCDate(formatDate(authorization.authorizationEndDate))
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Units
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.tcUnitsPerFrequency
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Frequency
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.tcFrequency
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Total Units
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.tcTotalUnits
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Unit Rate
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.tcCostOverride !== null && authorization.tcCostOverride !== undefined ? authorization.tcCostOverride : ( authorization.tcNegotiatedRate !== null && authorization.tcNegotiatedRate !== undefined ? authorization.tcNegotiatedRate : 'See Contracted Rates' )
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Status
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.currentStatus
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Auth Status
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.revisionIndicator === 'C' ? 'VOID' : ( moment(moment(formatDate(authorization.authorizationEndDate))).isSameOrAfter(moment()) ? 'OPEN' : 'CLOSED' )
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Cancel Auth
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.revisionIndicator==='C'?'Yes':'No'
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Revised
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.revisionIndicator==='1'?'Yes':'No'
                  }
                </div>
              </Col>
            </Row>
            <Row className="authorization-detail-row">
              <Col className="authorization-detail-left-col-row" xs={4}>
                <div className="authorization-detail-left-col">
									Details
                </div>
              </Col>
              <Col xs={8} className='authorization-detail-row-right'>
                <div className="authorization-detail-right-col">
                  {
                    authorization.authDetails
                  }
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default AuthorizationDetailModal